import React, {
  Fragment,
  useState,
  useContext,
  useRef,
  useEffect,
} from "react";

import {
  Grow,
  Popper,
  Paper,
  Grid,
  Button,
  ClickAwayListener,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import FulfillmentContext from "../../context/fulfillment/FulfillmentContext";

const DropdownMenu = ({ column, setColumnList }) => {
  const fulfillmentContext = useContext(FulfillmentContext);
  const { loading } = fulfillmentContext;

  const useStyles = makeStyles((theme) => ({
    paper: {
      backgroundColor: "#ffffff",
      paddingTop: theme.spacing(2),
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
  }));

  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  // return focus to the button when transitioned from !open -> open
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const [selectedColumn, setSelectedColumn] = useState([
    "Store Name",
    "Order ID",
    "SKU",
    "Quantity",
    "Total Quantity",
    "Amount",
    "Product Name",
    "Variant Title",
    "Name",
    "Address",
    "City",
    "Province",
    "Country",
    "Zip",
    "Phone",
    "Email",
    "Date Ordered",
    "Shipping Cost",
    "Product Cost",
  ]);

  const [forceRender, setForceRender] = useState(true);

  const onCheckBox = (e) => {
    if (selectedColumn.indexOf(e.target.id) < 0) {
      selectedColumn.push(e.target.id);
    } else {
      for (let x in selectedColumn) {
        if (selectedColumn[x] === e.target.id) {
          selectedColumn.splice(x, 1);
        }
      }
    }
    let list = [];
    for (let x in column) {
      if (selectedColumn.indexOf(column[x].title) >= 0) {
        list.push(column[x]);
      }
    }
    setColumnList(list);
    setSelectedColumn(selectedColumn);
    setForceRender(!forceRender);
  };

  const CheckBoxList = ({ each }) => {
    return (
      <FormControlLabel
        id={each}
        className={classes.buttonOutline}
        style={{
          height: "50%",
          fontSize: 12,
          width: "100%",
        }}
        control={
          <Checkbox
            id={each}
            className={classes.buttonOutline}
            checked={selectedColumn.indexOf(each) >= 0}
            onChange={onCheckBox}
            color="primary"
            style={{
              width: "35%",
              height: "50%",
            }}
          />
        }
        label={each}
      />
    );
  };

  return (
    <Fragment>
      <Button
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        variant="contained"
        color="primary"
        disabled={loading}
        endIcon={open ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
        onClick={handleToggle}
        className={classes.buttonOutline}
      >
        Show / Hide Column{" "}
      </Button>{" "}
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
        style={{
          zIndex: 1,
          width: 500,
        }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper elevation={3} className={classes.paper}>
              <ClickAwayListener onClickAway={handleClose}>
                <Grid container direction="row">
                  {" "}
                  {column.map((each, index) => {
                    return (
                      <Grid
                        item
                        xs={6}
                        style={{
                          height: 35,
                        }}
                        key={index}
                      >
                        <CheckBoxList each={each.title} />{" "}
                      </Grid>
                    );
                  })}{" "}
                </Grid>{" "}
              </ClickAwayListener>{" "}
            </Paper>{" "}
          </Grow>
        )}{" "}
      </Popper>{" "}
    </Fragment>
  );
};

export default DropdownMenu;
